module.exports = __webpack_public_path__ + "static/favicon-0f74c8e866097223a8ec4f746827f6f6.ico";